import { z } from 'zod/v4';

import { vehicleGroupStatsSchema } from './vehicle-group-stats.schema';

export const routingProfileStatsSchema = z.object({
  totalCount: z.number(),
  unUsedRoutingProfiles: z.array(
    z.object({
      routingProfileId: z.number(),
      name: z.string(),
      vehicleGroups: z.array(vehicleGroupStatsSchema),
      isDefault: z.boolean(),
    })
  ),
});

export type RoutingProfileStats = z.infer<typeof routingProfileStatsSchema>;
